import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="script" id="script"></a>
    <h1 {...{
      "id": "requireuxpscript"
    }}>{`require('uxp').script;`}</h1>
    <p>{`Script module, which contains essential properties and methods while writing scripts.`}</p>
    <a name="script-args" id="script-args"></a>
    <h2 {...{
      "id": "args--array"
    }}>{`args : `}<inlineCode parentName="h2">{`Array`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
To get the arguments(if any) passed by host app, while invoking the script.`}</p>
    <a name="script-executioncontext" id="script-executioncontext"></a>
    <h2 {...{
      "id": "executioncontext--executioncontext"
    }}>{`executionContext : `}<inlineCode parentName="h2">{`ExecutionContext`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
ExecutionContext passed by the host app, while invoking the script.`}</p>
    <a name="script-setresult" id="script-setresult"></a>
    <h2 {...{
      "id": "setresultresult"
    }}>{`setResult(result)`}</h2>
    <p>{`To send the execution result back to the host (if required).`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`result`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`HostDefinition`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Host defines the contract on what can be returned from scripts and its format.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      